import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Battle = makeShortcode("Battle");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Expedition 33 Expert Glitchless" mdxType="SEO" />
    <h1 {...{
      "id": "clair-obscur-expedition-33-expert-glitchless-route"
    }}>{`Clair Obscur: Expedition 33 Expert Glitchless Route`}</h1>
    <p>{`Last update: 1/24/26.`}</p>
    <p>{`This is the route for patches 61xxx and hopefully on. The really big changes were the removal of the hidden 10% damage boosts on Dead Energy II, First Strike, and Medalum. As a result, this route is significantly slower. And as of right now, it also has some pretty bad input delay issues. So if you are on PC and can downpatch, I recommend doing so.`}</p>
    <p>{`But if you can't, you're at the right place :)`}</p>
    <hr></hr>
    <h3 {...{
      "id": "notation"
    }}>{`Notation`}</h3>
    <p>{`For menus, I will sometimes have something in parenthesis. If it's (S1-3), it refers to the slot the Picto should be placed in. If it's a Playstation controller button, it's a button you should press to optimize the menu.`}</p>
    <p>{`For battles, there will sometimes be something like (1.1 QTE). This refers to the Quick Time Action you do when you use an Ability. A perfect is 1.2, a normal is 1.1, and a fail is 1.0. The number refers to the damage multiplier the skill gets from the QTE.`}</p>
    <p>{`Cutscene menu: you can open a menu right before you enter a cutscene transition, which will give you about 3s of menu time before the cutscene plays. You can use this to squeeze in menus and reduce wasted time. Menus will be labeled with which cutscenes they can be done during. Note that this seperates the menus, so if you're not doing cutscene menus you will want to combine them into one menu.`}</p>
    <hr></hr>
    <p>{`You can check the changelog at the bottom of the notes. This changelog will be restarted for this patch, so to check older stuff refer to the older patch notes.`}</p>
    <p>{`These are my personal notes for the category, the writing will reflect that. For the most part these notes will not say where to go or where things are, just what to do. I will be updating these as the route progresses, changes will be reflected in the changelog at the bottom of the notes.`}</p>
    <p>{`There will also be enemy data and maybe some other useful information at the bottom of the notes.`}</p>
    <p>{`If there's a time listed by a fight, it's my best time for it so far. It does not represent the average.`}</p>
    <h2 {...{
      "id": "prologue"
    }}>{`Prologue`}</h2>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "maelle-450hp-024-027"
      }}>{`Maelle 450HP (0:24-0:27)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1XP, $50, Colour of Lumina`}</p>
      </blockquote>
      <p>{`Option 1: Attack > Parry > Overcharge > Parry > Attack (0:24 w/crit, 0:27 without)`}<br parentName="p"></br>{`
`}{`Option 2: Attack > Parry > Attack > Dodge, Overcharge (0:26). If you get hit instead of dodging add 1 shot.`}</p>
      <p>{`On average, optimal choice is probably to go for Option 2 if you don't get the parry crit T1.`}<br parentName="p"></br>{`
`}{`If you crit an attack with Option 2, you can save 1s by intentionally getting hit by 1 of Maelle's 3 hits.`}</p>
    </Battle>
    <h3 {...{
      "id": "harbor"
    }}>{`Harbor`}</h3>
    <ul>
      <li parentName="ul">{`Talk to Aprentices`}</li>
      <li parentName="ul">{`Talk to Maelle, skip Maelle duel`}</li>
      <li parentName="ul">{`Talk to Emma`}</li>
    </ul>
    <p>{`4 CS on Transition`}</p>
    <h2 {...{
      "id": "act-i"
    }}>{`Act I`}</h2>
    <h3 {...{
      "id": "spring-meadows"
    }}>{`Spring Meadows`}</h3>
    <Menu timing="Cutscene entering Lancelier or Portier battle" mdxType="Menu">
      <h5 {...{
        "id": "skills"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Lumiere Assault Top-Right`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "lancelier-122hp-6xp-50-010"
      }}>{`Lancelier 122HP 6XP $50 (0:10)`}</h4>
      <ul>
        <li parentName="ul">{`Shoot Weak Spot, Attack > Parry`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "portier-450hp-008"
      }}>{`Portier 450HP (0:08)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`10XP, $75, Dodger + 0-2 Chroma Catalyst `}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`You can shoot 2 extra times with Gustave. If he crits the attack, you can then shoot twice with Lune and Immolation to kill.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot weak spot, Attack`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`For the AoE attack, start mashing dodge as soon as his arms touch together. After 3 dodges, parry.`}</p>
      </blockquote>
      <p>{`Counter to kill.`}</p>
    </Battle>
    <p>{`Pick up `}<strong parentName="p">{`Critical Burn`}</strong>{`.`}<br parentName="p"></br>{`
`}{`First strike the Lanceram before the house.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "2-lancelier-240hp-019"
      }}>{`2 Lancelier 240HP (0:19)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`53XP, $144, Lanceram LV1`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot weak spots, Attack`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <p>{`Parry.`}</p>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Attack`}</li>
      </ul>
    </Battle>
    <p>{`You can jump up to the right side before the house, or take the path through the house.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Energy Tint Shard`}</strong>{`, `}<strong parentName="p">{`$360`}</strong>{` in house detour.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "3-volester-81hp-017"
      }}>{`3 Volester 81HP (0:17)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`43XP, $216, 0-2 Chroma Catalyst?`}<br parentName="p"></br>{`
`}{`Parry timing is on slowdown/freeze frames on both of their attacks`}</p>
      </blockquote>
      <p>{`Parry both attacks. Shoot last one to death. Requires 5AP.`}</p>
    </Battle>
    <Menu timing="Entering journal cutscene" mdxType="Menu">
      <h5 {...{
        "id": "weapon"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Lanceram`}</li>
      </ul>
      <h5 {...{
        "id": "pictos"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustav`}<ul parentName="li">
            <li parentName="ul">{`+Dodger`}</li>
            <li parentName="ul">{`+Critical Burn`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Dead Energy II`}</strong>{`. Afterwards, jump off to the left and menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-1"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustav`}<ul parentName="li">
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`First strike the Abbest on your left.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "2-volester-1-abbest-009"
      }}>{`2 Volester, 1 Abbest (0:09)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$216, 55XP`}<br parentName="p"></br>{`
`}{`If you missed XP after Portier, take the fight before Eveque instead. Strat for that fight is in the archive section of these notes.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-1"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Gustav:`}<ul parentName="li">
            <li parentName="ul">{`Shoot each Volester 3 times, don't hit weakness.`}</li>
            <li parentName="ul">{`Shoot Abbest weakness, skip.`}</li>
          </ul></li>
        <li parentName="ul">{`Lune: Ice Lance (1.1)`}</li>
      </ul>
    </Battle>
    <p>{`Go to Flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: +9 Might (9)`}</li>
        <li parentName="ul">{`Lune: +9 Might (9)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot, Powerful (in that order)`}</li>
      </ul>
    </Menu>
    <Menu timing="Cutscene entering Eveque fight" mdxType="Menu">
      <h5 {...{
        "id": "weapon-1"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lighterim`}</li>
      </ul>
      <p><em parentName="p">{`If missed, equip in Flying Waters`}</em></p>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "eveque-4524hp-204"
      }}>{`Eveque 4524HP (2:04)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$862, Cleansing Tint, 5 Chroma Catalyst, 0-2 Recoat`}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`The chance of you getting the fast fight are much lower on this patch.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: (If Gustave target shoot 1 shield), Powerful`}</li>
        <li parentName="ul">{`Lune: Shoot off shields (last shield shoot weakpoint), Shoot till 3AP, Immolation`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Lune: Immolation`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot till 2AP, Marking Shot`}</li>
        <li parentName="ul">{`Lune: Energising Tint Gustave`}</li>
      </ul>
      <p>{`Stop countering Eveque on this turn, until you do the Overcharge.`}<br parentName="p"></br>{`
`}{`You can kill one Abbest for AP generation & speeding up the backup. Killing both before Eveque will break the XP route.`}</p>
      <h5 {...{
        "id": "turn-4"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Overcharge`}</li>
      </ul>
      <p>{`If not dead, shoot off shields and damage as best as you can.`}<br parentName="p"></br>{`
`}{`If it was no crit and Eveque is still healthy, don't counter it's attack so it starts charging up. You can then inflict a good chunk of damage by shooting the core again.`}</p>
    </Battle>
    <h3 {...{
      "id": "continent"
    }}>{`Continent`}</h3>
    <p>{`Go to Camp before entering Flying Waters`}</p>
    <h3 {...{
      "id": "flying-waters"
    }}>{`Flying Waters`}</h3>
    <Menu timing="Cutscene at start of area or before entering Manor" mdxType="Menu">
      <h5 {...{
        "id": "pictos-2"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Remove All`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`$333`}</strong>{` along path.`}</p>
    <p>{`Take the detour to the right by the tunnel to spawn 3 Demineur and fight them.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "3-demineur-218hp-004"
      }}>{`3 Demineur 218HP (0:04)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1180XP $399`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-2"
      }}>{`Turn 0`}</h5>
      <p>{`Shoot the 3 bombs`}</p>
    </Battle>
    <p>{`Go to Manor.`}</p>
    <Menu timing="Cutscene entering Maelle's room" mdxType="Menu">
      <h5 {...{
        "id": "pictos-3"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Jump towards flag.`}</p>
    <Menu timing="When you land near flag" mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`This menu is unnecessary, it was used when you had to wait for dialogue to end to menu. However, I'm used to it so I'm leaving this in for muscle memory.`}</p>
      </blockquote>
      <h5 {...{
        "id": "skills-1"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Top-Right slot equip Spark`}</li>
      </ul>
    </Menu>
    <p>{`Interact with flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-1"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: +6 Agility (6)`}</li>
        <li parentName="ul">{`Maelle: +15 Might (15)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-1"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
        <li parentName="ul">{`Lune: +Thunderfall, +Wildfire, +Electrify`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "the-curator-hp-024"
      }}>{`The Curator ?HP (0:24)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`720XP, $376`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Maelle: Offensive Shift`}</li>
        <li parentName="ul">{`Lune: Skip`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
    </Battle>
    <p>{`Talk to Noco and fight him.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "noco-1670hp-022"
      }}>{`Noco 1670HP (0:22)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`486XP $200 `}</p>
      </blockquote>
      <p>{`Offensive Shift > Parry > 1 Shot, Spark`}</p>
    </Battle>
    <p>{`Buy `}<strong parentName="p">{`Exposing Attack ($3600)`}</strong>{`. After Noco continue straight.`}<br parentName="p"></br>{`
`}{`Fight the `}<strong parentName="p">{`Bruler`}</strong>{` that jumps down at you before the tunnel`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "demineur-bruler-luster-014"
      }}>{`Demineur, Bruler, Luster (0:14)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1412XP, $466, Bruleram LV3`}<br parentName="p"></br>{`
`}{`You get ~72 more EXP here by killing Bruler first.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-3"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot Mine, Marking Shot Bruler`}</li>
        <li parentName="ul">{`Lune: Skip`}</li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`Shoot Bruler weakspot (kill)`}</li>
            <li parentName="ul">{`Shoot Demineur head once, anywhere once`}</li>
            <li parentName="ul">{`Shoot rest of AP at Luster weakspot, if he lives Attack`}</li>
          </ul></li>
      </ul>
    </Battle>
    <Menu timing="Coral Cave flag" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-2"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: +4 Might (13), +1 Agility (7)`}</li>
        <li parentName="ul">{`Maelle: +2 Might (17), +1 Agility (1)`}</li>
        <li parentName="ul">{`Lune: +8 Might (17), +4 Agility (4)`}</li>
      </ul>
    </Menu>
    <Menu timing="Anytime before Goblu" mdxType="Menu">
      <h5 {...{
        "id": "weapon-2"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Bruleram`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-4"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Exposing Attack`}</li>
          </ul></li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Dead Energy II isn't needed anymore for this fight since no more damage boost. However, leaving it in since Verso eventually uses it outside Monoco Station and Lune on Mask Keeper`}</p>
      </blockquote>
      <h5 {...{
        "id": "lumina"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
        <li parentName="ul">{`Gustav`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "goblu-22815hp-137"
      }}>{`Goblu 22815HP (1:37)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`3240XP, $1330, 0-2? Recoat`}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`The main fight now is the 5T, as getting a fast fight is near impossible now.`}<br parentName="p"></br>{`
`}{`I'd only go for it if you got both Maelle counter and Percee crit.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-4"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Maelle: Offensive Shift`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-1"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Gustav: Overcharge`}</li>
        <li parentName="ul">{`Maelle: Can shoot till 3ATB, Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-5"
      }}>{`Turn 5`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <p>{`If still alive, do Turn 5 again.`}</p>
      <p>{`If you got REALLY good damage, replace turns 3 & 4 with:`}</p>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustav: Overcharge`}</li>
        <li parentName="ul">{`Maelle: Can shoot till 3ATB, Swift Stride`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "ancient-sanctuary"
    }}>{`Ancient Sanctuary`}</h3>
    <p>{`Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-3"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +6 Might (23)`}</li>
      </ul>
    </Menu>
    <p>{`Go fight the Petank`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "petank"
      }}>{`Petank`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$3860, 5 Polished, 5 Lumina, 1 Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-5"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustave: Powerful`}</li>
        <li parentName="ul">{`Maelle: Swift Stride (Full QTE)`}</li>
      </ul>
      <p>{`Dodge his attack.`}</p>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Gustave: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: 3 Shots, Percee`}</li>
        <li parentName="ul"><em parentName="li">{`If still alive`}</em>{` Lune: Thunderfall`}</li>
      </ul>
    </Menu>
    <Menu timing="Cutscene entering Robust Sakapatate fight" mdxType="Menu">
      <h5 {...{
        "id": "lumina-1"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +Dodger`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "robust-sakapatate-5792hp-039"
      }}>{`Robust Sakapatate 5792HP (0:39)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1824XP, $435, Sakaram Lv.4`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Swings with it's partner: 1 Hit AoE`}</li>
          <li parentName="ul">{`Slams it's shield: 1 Hit AoE, raises Shield and will counter next time its hit.`}</li>
          <li parentName="ul">{`Shield counter: 1 hit AoE, need to dodge sooner than Slams it's shield.`}</li>
          <li parentName="ul">{`Clunky Combo: 2 hit, jump, 1 hit. Has easy audio cue`}</li>
        </ul>
      </blockquote>
      <p>{`Parry his shield attack (prevents him countering later). You can dodge everything else.`}</p>
      <h5 {...{
        "id": "turn-1-6"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation (Fail QTE)`}</li>
        <li parentName="ul">{`Gustav: Skip`}</li>
        <li parentName="ul">{`Maelle: Swift Stride (Fail QTE)`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-4"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
    </Battle>
    <blockquote>
      <p parentName="blockquote">{`Note that if you miss no XP, you can get Rain of Fire before Ultimate Sakapatate.`}<br parentName="p"></br>{`
`}{`If so, take the flag before Ultimate Sakapatate, max Maelle Might, teach RoF, and skip the Gestral Village flag. For the fight, replace Percee with RoF.`}</p>
    </blockquote>
    <Menu timing="Cutscene menu entering Ultimate Sakapatate" mdxType="Menu">
      <h5 {...{
        "id": "weapons"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Sakaram`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "ultimate-sakapatate-28236hp-144"
      }}>{`Ultimate Sakapatate 28236HP (1:44)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`8100XP, $1930, Breaker + 3 Polished Catalyst + 0-2 Recoats`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Slams the ground: 1 hit AoE, naturally parry timing.`}</li>
          <li parentName="ul">{`Fires it's Cannons: look for Fire on it's cannons as indicator, parry when you see it.`}</li>
          <li parentName="ul">{`Slams it's shield: 1 hit single target.`}</li>
          <li parentName="ul">{`Combo: 2 hits into jump, dodge the first 2 no point in parrying.`}</li>
          <li parentName="ul">{`Launches weird elecric things: 3 hit single target: Parry once they're top of their arc / flying down.`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-1-7"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-5"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Shoot once, then shoot shoulder 3 times to break it. Attack.`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If Gustave doesn't have 5AP, you can Powerful instead, or just Attack.`}<br parentName="p"></br>{`
`}{`With no Percee crit, I recommend going for Powerful even if you have Overcharge AP.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustav: Overcharge`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-2"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack / Energy Tint Gustave if he has 0 AP.`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <p>{`If still alive, repeat turn 4`}</p>
    </Battle>
    <h3 {...{
      "id": "gestral-village"
    }}>{`Gestral Village`}</h3>
    <Menu timing="Flag at entrance" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-4"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +6 Might (29)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-2"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Degagement, Rain of Fire`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "tournament"
    }}>{`Tournament`}</h3>
    <p>{`Pattern for first 3 fights: Parry, `}<strong parentName="p">{`Degagement`}</strong>{`, Parry, Rain of Fire`}<br parentName="p"></br>{`
`}{`Rewards for each: 2026XP, $366`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "bertrand-big-hands-022"
      }}>{`Bertrand Big Hands (0:22)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Swinging Right Hook x2, Left Uppercut (parry end of windup)`}</p>
      </blockquote>
      <h4 {...{
        "id": "dominique-giant-feet-027"
      }}>{`Dominique Giant Feet (0:27)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Two-handed Ground Pound x2, Right Handed Ground Pound (Parry indicator is his elbow pointing up)`}</p>
      </blockquote>
      <h4 {...{
        "id": "matthieu-the-colossus-023"
      }}>{`Matthieu the Colossus (0:23)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Left Hook x2, Right `}<strong parentName="p">{`Feint`}</strong>{` into Left Uppercut (Parry as he swings)`}</p>
      </blockquote>
      <h4 {...{
        "id": "sciel-3211hp-024"
      }}>{`Sciel 3211HP (0:24)`}</h4>
      <p>{`Parry, Rain of Fire, Parry`}</p>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Sealed Fate: 3 Hit`}</li>
          <li parentName="ul">{`Twilight Slash: 1 Hit`}</li>
          <li parentName="ul">{`Marking Card: 2 hit projectile, Parry as circle closes.`}</li>
        </ul>
      </blockquote>
      <p>{`You need to win vs Sciel for this route.`}</p>
    </Battle>
    <p>{`Talk to Golgra. Then go talk to Jujubree (Merchant).`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`2 Polished Chroma Catalyst (6 Total)`}</li>
        <li parentName="ul">{`Critical Moment`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "camp"
    }}>{`Camp`}</h4>
    <p>{`Talk to Curator`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lighterim +7 (8)`}</li>
        <li parentName="ul">{`Maelle: Medalum +1 (6)`}</li>
      </ul>
    </Menu>
    <p>{`Sleep. Go to Esquie's Nest.`}</p>
    <h3 {...{
      "id": "esquies-nest"
    }}>{`Esquie's Nest`}</h3>
    <Menu timing="Flag at entrance" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-5"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: +13 Agility (20)`}</li>
        <li parentName="ul">{`Lune: +15 Might (29)`}</li>
        <li parentName="ul">{`Sciel: +44 Might (44), +1 Agility (1)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-3"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lightning Dance, Equip to Bottom-Left slot`}</li>
        <li parentName="ul">{`Sciel: `}<strong parentName="li">{`Phantom Blade`}</strong>{`, Intervention, Equip Intervention to Top Left slot`}</li>
      </ul>
    </Menu>
    <Menu timing="Cutscene with Gestral guard" mdxType="Menu">
      <h5 {...{
        "id": "weapons-1"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Medalum`}</li>
      </ul>
    </Menu>
    <Menu timing="Cutscene meeting Esquie" mdxType="Menu">
      <h5 {...{
        "id": "pictos-5"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustave:`}<ul parentName="li">
            <li parentName="ul">{`+Critical Moment`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-2"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`If you didn't get the Weapons and Critical Moment equipped, do so before Francois fight.`}<br parentName="p"></br>{`
`}{`You can cutscene menu entering Francois fight for anything you missed earlier.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "francois-9652hp-018"
      }}>{`Francois 9652HP (0:18)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`2228XP, $392, 345SPD, Augmented First Strike + 0-2 Polished Chroma Catalyst`}</p>
      </blockquote>
      <p>{`Dodge his attacks, use rhythm like Eveque spells`}</p>
      <h5 {...{
        "id": "turn-1-8"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Maelle: Shoot 3 times, Percee`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Better to shoot with Maelle because you don't have to move your aim at all.`}</p>
      </blockquote>
    </Battle>
    <p>{`Backtrack to Esquie.`}</p>
    <Menu timing="Cutscene talking to Esquie" mdxType="Menu">
      <h5 {...{
        "id": "pictos-6"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Breaker`}</li>
            <li parentName="ul">{`+Augmented First Strike`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`After talking to Esquie, run to flag by Francois and fast travel to entrance. Exit to Continent.`}</p>
    <h3 {...{
      "id": "the-continent"
    }}>{`The Continent`}</h3>
    <p>{`Mount Esquie and Camp.`}</p>
    <h4 {...{
      "id": "camp-1"
    }}>{`Camp`}</h4>
    <h3 {...{
      "id": "the-continent-1"
    }}>{`The Continent`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`Energising Start I`}</strong>{` on beach west of `}<strong parentName="p">{`Stone Wave Cliffs`}</strong><br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`$1305`}</strong>{` after breaking the rocks to Stone Wave Cliffs`}</p>
    <h3 {...{
      "id": "stone-wave-cliffs"
    }}>{`Stone Wave Cliffs`}</h3>
    <Menu timing="Cutscene at start of area" mdxType="Menu">
      <h5 {...{
        "id": "pictos-7"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Energising Start I`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`$790`}</strong>{` on the left before the 1st flag.`}</p>
    <p><strong parentName="p">{`Go break the paint cage and get Delaram`}</strong>{`.`}</p>
    <p>{`Pick up `}<strong parentName="p">{`First Strike`}</strong>{`. Menu on the jump down.`}</p>
    <Menu timing="After First Strike, before Rocher" mdxType="Menu">
      <h5 {...{
        "id": "pictos-8"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustave:`}<ul parentName="li">
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-3"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Gustav:`}<ul parentName="li">
            <li parentName="ul">{`-Critical Burn`}</li>
            <li parentName="ul">{`+Exposing Attack`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`First Strike the Rocher after the Paintress Shrine`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "rocher-011"
      }}>{`Rocher (0:11)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1575XP, $316`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-4"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Marking Shot`}</li>
        <li parentName="ul">{`Lune: Wildfire (Fail QTE)`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`$790`}</strong>{` after Farm flag.`}</p>
    <Menu timing="Before Lampmaster" mdxType="Menu">
      <h5 {...{
        "id": "formation"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`-Maelle, +Sciel`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-9"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Critical Moment`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` before last grapple up.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "lampmaster-42677hp-148"
      }}>{`Lampmaster 42677HP (1:48)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`18900XP, $3160, 3 Polished Chroma Catalyst`}<br parentName="p"></br>{`
`}{`Need > 310 speed to outspeed him T2. 312 confirmed working.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Switches off lights and attacks: 4 Lamps launch projectiles. Parry when lamps turn off.`}</li>
          <li parentName="ul">{`Jumps: Parry on landing.`}</li>
          <li parentName="ul">{`Power of its lamps: 1 Dark Attack, visual/audio pre attack cue?`}</li>
          <li parentName="ul">{`Tries to blind: 3 Physical, first swipe is later than it looks.`}</li>
          <li parentName="ul">{`Dark explosion: jumps and hits 1 on landing.`}</li>
        </ul>
      </blockquote>
      <p>{`In phase 1, you need to counter 3 or 4 attacks. Need about 4000ish damage of extra counter damage.`}</p>
      <p><strong parentName="p">{`Bonus Strats`}</strong><br parentName="p"></br>{`
`}{`After his first attack, you can do the following if you generated enough AP from dodges/parries.`}<br parentName="p"></br>{`
`}{`+2 Sciel AP: Skip the Tint on Sciel`}<br parentName="p"></br>{`
`}{`+3 Lune AP: Lune Ice Lance, Gustave Powerful, Sciel Tint Lune. Next turn, Lightning Dance, Gustave Tint Lune, Sciel Attack. Continue from Turn 3. If you do enough damage that you end phase 1 with Lightning Dance, you can Intervention > Wildfire early.`}</p>
      <h5 {...{
        "id": "turn-0-5"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-9"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Gustav: Tint Sciel`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Attack`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-6"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`Enter phase 2.`}</p>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Flying Combo: 4 hits, parry bit after audio cue`}</li>
          <li parentName="ul">{`Attacks with each arm: 4 hits, parry on audio cue?`}</li>
          <li parentName="ul">{`Vast ball of light: Jump, easy timing`}</li>
          <li parentName="ul">{`Sword of light: 1 hit, parry during it's swing at you`}</li>
        </ul>
      </blockquote>
      <p>{`You can dodge both moves, perfect dodge the Sword.`}</p>
      <h5 {...{
        "id": "turn-21"
      }}>{`Turn 2.1`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Tint Lune`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Attack`}</li>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "white-haired-man-049"
      }}>{`White-Haired Man (0:49)`}</h4>
      <p>{`Skip turn x4`}</p>
    </Battle>
    <h2 {...{
      "id": "act-ii"
    }}>{`Act II`}</h2>
    <h3 {...{
      "id": "camp-2"
    }}>{`Camp`}</h3>
    <p>{`Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-6"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +9 Agility (13)`}</li>
        <li parentName="ul">{`Verso: +32 Might (32), +10 Agility (10)`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`The order for Verso's skills here matters.`}</p>
        <h5 parentName="blockquote" {...{
          "id": "learn-skills-4"
        }}>{`Learn Skills`}</h5>
        <ul parentName="blockquote">
          <li parentName="ul">{`Verso: Marking Shot, Quick Strike, Berserk Slash, Defiant Strike, Powerful`}</li>
          <li parentName="ul">{`Verso: Equip Berserk Slash Left-Middle, Equip Powerful Left-Bottom.`}</li>
        </ul>
      </blockquote>
    </Menu>
    <h3 {...{
      "id": "continent-1"
    }}>{`Continent`}</h3>
    <Menu timing="Before entering Forgotten Battlefield" mdxType="Menu">
      <h5 {...{
        "id": "weapon-3"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Delaram`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-10"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso`}<ul parentName="li">
            <li parentName="ul">{`+At Death's Door`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "forgotten-battlefield"
    }}>{`Forgotten Battlefield`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "chalier-9724hp-024"
      }}>{`Chalier 9724HP (0:24)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`4134XP (NB), $593, 0-2 Polished Chroma Catalyst`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-10"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Dodge 1st attack`}</li>
        <li parentName="ul">{`Verso: Defiant Strike`}</li>
        <li parentName="ul">{`Let Verso die to Gradient`}</li>
        <li parentName="ul">{`Lune: Skip`}</li>
        <li parentName="ul">{`Maelle: Percee (1.1)`}</li>
      </ul>
    </Battle>
    <p>{`Buy `}<strong parentName="p">{`Inverted Affinity`}</strong>{` from Merchant ($11280).`}</p>
    <Menu timing="Jump down from Merchant" mdxType="Menu">
      <h5 {...{
        "id": "pictos-11"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Inverted Affinity`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-4"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`-Exposing Attack`}</li>
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Critical Moment`}</li>
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "formation-1"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`-Maelle, +Sciel`}</li>
      </ul>
    </Menu>
    <Menu timing="Cutscene entering Dualliste" mdxType="Menu">
      <h5 {...{
        "id": "pictos-12"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Remove All`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "dualliste-71106hp-200"
      }}>{`Dualliste 71106HP (2:00)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`33072XP, $3950, Dualiso + Combo Attack I + 3 Polished Chroma Catalyst + 0-1 Recoat?`}<br parentName="p"></br>{`
`}{`Threshold between him getting 2 attacks before you is somewhere between 328 and 318 speed.`}</p>
      </blockquote>
      <p>{`You can dodge all moves. Verso can parry to generate AP, no counter damage is needed.`}</p>
      <h5 {...{
        "id": "turn-0-6"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-11"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Tint Verso / Nothing`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Attack`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-7"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Tint Verso / Nothing`}</li>
        <li parentName="ul">{`Verso: Berserk Slash / Defiant Strike`}</li>
      </ul>
      <p>{`Phase change.`}</p>
      <h5 {...{
        "id": "turn-21-1"
      }}>{`Turn 2.1`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
      <p>{`Parry + Dodge AoE for AP generation.`}</p>
      <h5 {...{
        "id": "turn-3-4"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack / Skip if very good damage.`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
    </Battle>
    <Menu timing="Gustave's funeral cutscene" mdxType="Menu">
      <h5 {...{
        "id": "pictos-13"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +Combo Attack`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "camp-3"
    }}>{`Camp`}</h3>
    <p>{`Go to Curator`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons-1"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lighterim +1 (9)`}</li>
        <li parentName="ul">{`Sciel: Scielson +1 (6)`}</li>
      </ul>
    </Menu>
    <p>{`Option 2 to sleep.`}</p>
    <h3 {...{
      "id": "continent-2"
    }}>{`Continent`}</h3>
    <p>{`First Strike group before Monoco Station`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "demineur-troubador-gault-015"
      }}>{`Demineur, Troubador, Gault (0:15)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`6890XP (NB), $988, Troubadim LV8 + Gaulteram LV8 + 0-1? Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-7"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Wildfire (Fail QTE)`}</li>
        <li parentName="ul">{`Verso: `}<ul parentName="li">
            <li parentName="ul">{`Shoot Mine then shoot Demineur 2 times.`}</li>
            <li parentName="ul">{`Defiant Strike Troubador`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel: Phantom Blade Gault`}</li>
      </ul>
    </Battle>
    <Menu timing="Anytime before Monoco fight" mdxType="Menu">
      <h5 {...{
        "id": "weapon-4"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Dualiso`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-14"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Combo Attack > At Death's Door (Swap)`}</li>
            <li parentName="ul">{`+Critical Moment > First Strike (Swap)`}</li>
            <li parentName="ul">{`+Exposing Attack > Inverted Affinity (Swap)`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-5"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Critical Moment`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`(R3) +First Strike`}</li>
            <li parentName="ul">{`-Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "monoco-station"
    }}>{`Monoco Station`}</h3>
    <Menu timing="Cutscene entering Monoco fight" mdxType="Menu">
      <h5 {...{
        "id": "lumina-6"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso: `}<ul parentName="li">
            <li parentName="ul">{`-Critical Burn`}</li>
            <li parentName="ul">{`-Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "monoco-111599hp-030"
      }}>{`Monoco 111599HP (0:30)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`54000XP, $4360, 3 Polished Chroma Catalyst + 0-1 Recoat. Speed between 346-349`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-8"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation `}</li>
        <li parentName="ul">{`Sciel: Energy Tint Lune`}</li>
      </ul>
      <p>{`Dodge his attack.`}</p>
      <h5 {...{
        "id": "turn-1-12"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Powerful`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "stalact-51507hp-048"
      }}>{`Stalact 51507HP (0:48)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`21600XP, $1744, Polished Chroma Catalyst + 0-1 Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-9"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Ice Lance (Fail QTE)`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Gradient > Lightning Dance`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "old-lumiere"
    }}>{`Old Lumiere`}</h3>
    <Menu timing="Jump down at start" mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`TODO: Lumina menu strucure needs work here.`}</p>
      </blockquote>
      <h5 {...{
        "id": "pictos-15"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune`}<ul parentName="li">
            <li parentName="ul">{`+Energising Start I > At Death's Door (No Swap)`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-7"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune: `}<ul parentName="li">
            <li parentName="ul">{`-Dodger`}</li>
            <li parentName="ul">{`+At Death's Door`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`(R3) +Inverted Affinity`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle: `}<ul parentName="li">
            <li parentName="ul">{`+Inverted Affinity`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Monoco:`}<ul parentName="li">
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Inverted Affinity`}</li>
            <li parentName="ul">{`+Energising Start I`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <p>{`Talk to flag.`}</p>
      <h5 {...{
        "id": "upgrade-attributes-7"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Recoat, +15 Might, +36 Agility, +9 Luck`}</li>
        <li parentName="ul">{`Verso: +18 Agility (28)`}</li>
        <li parentName="ul">{`Maelle: +21 Might (53)`}</li>
        <li parentName="ul">{`Monoco: +78 Agility (78)`}</li>
        <li parentName="ul">{`Sciel: +5 Might (49), +5 Agility (5), +9 Luck (9)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-5"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +Mayhem, +Elemental Trick`}</li>
        <li parentName="ul">{`Lune: Equip Elemental Trick Left-Top`}</li>
        <li parentName="ul">{`Verso: +Perfect Recovery, +Leadership`}</li>
        <li parentName="ul">{`Verso: Equip Leadership Left-Top, Perfect Recovery Right-Top`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "chevaliers-013"
      }}>{`Chevaliers (0:13)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`13662XP, $998, Battlum LV10 + 0-2 Polished Chroma Catalyst`}<br parentName="p"></br>{`
`}{`Verso outspeeds at 522 speed, 521 might work.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-10"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Rain of Fire (Perfect QTEs). You're hoping for no crits`}</li>
        <li parentName="ul">{`Verso: If left Chevalier survived, shoot head 3 times (need to confirm). Then Berserk Slash. If it died, Attack > Berserk Slash`}</li>
      </ul>
    </Battle>
    <blockquote>
      <p parentName="blockquote">{`You can cutscene menu before Renoir to fix any missed Maelle Picto / Lumina stuff earlier.`}<br parentName="p"></br>{`
`}{`I think removing Percee here will make Stendhal go Left-Middle by default, but untested.`}</p>
    </blockquote>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "renoir-140186hp-050"
      }}>{`Renoir 140186HP (0:50)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`51750XP (NB), $4990, Melarum + 3 Polished Chroma Catalyst + 0-2 Recoat`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Massive amount of chroma: Gradient once he jumps into the air.`}</li>
          <li parentName="ul">{`Melee combo: 5, 4th hit is later than it looks.`}</li>
          <li parentName="ul">{`Giant pool of chroma: jump`}</li>
          <li parentName="ul">{`Attacks from a distance: 4 hit, look for slowdown.`}</li>
          <li parentName="ul">{`Vanish an expeditioner: Gradient before he strikes black orb.`}</li>
        </ul>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`You probably want to counter 1 move on this fight.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-13"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Rain of Fire`}</li>
        <li parentName="ul">{`Lune: Wildfire `}<strong parentName="li">{`(Fail QTE)`}</strong></li>
        <li parentName="ul">{`Verso: Powerful`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-8"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Energy Tint Lune`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Maelle: Healing Tint Lune if she didn't crit herself / Nothing / Offensive Switch`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-5"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Leadership / Energy Tint. If you did Offensive Switch can just do the Leadership / Energy Tint`}</li>
        <li parentName="ul">{`Lune: Lightning Dance (1.2)`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "camp-4"
    }}>{`Camp`}</h3>
    <p>{`Go to sleep.`}</p>
    <h3 {...{
      "id": "continent-3"
    }}>{`Continent`}</h3>
    <h3 {...{
      "id": "visages"
    }}>{`Visages`}</h3>
    <Menu timing="Cutscene before flag" mdxType="Menu">
      <h5 {...{
        "id": "formation-2"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`-Lune, +Lune, -Maelle, +Monoco`}</li>
      </ul>
      <h5 {...{
        "id": "weapons-2"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Delaram`}</li>
      </ul>
    </Menu>
    <p><strong parentName="p">{`Talk to the Plazza Flag`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Sadness Vale`}</strong>{`.`}</p>
    <Menu timing="Cutscene entering Sadness Vale" mdxType="Menu">
      <h5 {...{
        "id": "pictos-16"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: +Combo Attack`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Resplendent Chroma Catalyst`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Glass Cannon`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Take flag back to `}<strong parentName="p">{`Plazza`}</strong>{`.`}</p>
    <p>{`Go to Joyous Vale (Back left)`}</p>
    <Menu timing="Cutscene transition entering Mask" mdxType="Menu">
      <h5 {...{
        "id": "pictos-17"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Monoco: +Glass Cannon`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Confident Fighter`}</strong>{`.`}</p>
    <Menu timing="Before Moisonneusse fight" mdxType="Menu">
      <h5 {...{
        "id": "pictos-18"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`(Triangle) +Confident Fighter > Energising Start I`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-8"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`-Critical Burn`}</li>
            <li parentName="ul">{`+Energising Start I`}</li>
            <li parentName="ul">{`+At Death's Door`}</li>
            <li parentName="ul">{`+`}<strong parentName="li">{`Augmented First Strike`}</strong></li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`At Death's Door`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Run into fight closest to flag.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "2-moisonneusse-hat-guy"
      }}>{`2 Moisonneusse Hat Guy`}</h4>
      <ul>
        <li parentName="ul">{`Verso: Perfect Recovery`}</li>
        <li parentName="ul">{`Lune: Wildfire (Fail QTE)`}</li>
        <li parentName="ul">{`Monoco: Flee`}</li>
      </ul>
    </Battle>
    <p>{`Go to flag, warp to `}<strong parentName="p">{`Plazza`}</strong>{`.`}</p>
    <p>{`Go to Merchant.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`5 Resplendant Catalyst`}</li>
      </ul>
    </Menu>
    <Menu timing="Before Mask Keeper" mdxType="Menu">
      <h5 {...{
        "id": "formation-3"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`-Monoco, +Sciel`}</li>
      </ul>
      <h5 {...{
        "id": "weapon-5"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Dualiso`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-19"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso`}<ul parentName="li">
            <li parentName="ul">{`+Glass Cannon`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "visages-185114hp"
      }}>{`Visages 185114HP`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Need 440 speed for phase 1`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Determination Mask: Parry, Jump, Parry. Very easy audio cues`}</li>
          <li parentName="ul">{`Build shields with Peace Mask: 4 Parries on audio cue`}</li>
          <li parentName="ul">{`Anxiety Mask: 2 Parry, slight delay from audio cue.`}</li>
          <li parentName="ul">{`Doubt Mask: 5 Parry, go off visual cues. 1st one is slower than it looks. Audio cue is too early.`}</li>
        </ul>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`There's lot's of variations here, I'll just put the slow consistent version for now.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-11"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Shoot twice, Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`Parry & Counter for damage.`}</p>
      <h5 {...{
        "id": "turn-1-14"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Leadership`}</li>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Gradient (Should kill) > Energy Tint Sciel`}</li>
      </ul>
      <h4 {...{
        "id": "mask-keeper-185114hp-220"
      }}>{`Mask Keeper 185114HP (2:20?)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`157690XP, $11760, Immaculate + 6 Resplendent Chroma Catalyst x6 + 0-3 Recoat`}<br parentName="p"></br>{`
`}{`Need some amount of speed over 468.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Attacks the Expedition: 4 Parries, visual cue off the circle build up of his attack.`}</li>
          <li parentName="ul">{`Swing Combo: 3 Parry, 2nd Parry tiny delay after 1st.`}</li>
          <li parentName="ul">{`Attacks like a Storm: 4 parries, visual/audio cue.`}</li>
          <li parentName="ul">{`Sets fire to his sword: 3 quick parries into a gradient`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-1-15"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Powerful`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Sciel: Intervention`}</li>
        <li parentName="ul">{`Lune: Gradient > Lightning Dance`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "camp-5"
    }}>{`Camp`}</h3>
    <p>{`Go to Curator.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons-2"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Scieleson +5 (11)`}</li>
        <li parentName="ul">{`Lune: Lighterim +5 (14)`}</li>
      </ul>
    </Menu>
    <p>{`Go to sleep.`}</p>
    <h3 {...{
      "id": "sirene"
    }}>{`Sirene`}</h3>
    <Menu timing="Cutscene at entrance before elevator" mdxType="Menu">
      <h5 {...{
        "id": "pictos-20"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: `}<ul parentName="li">
            <li parentName="ul">{`(Triangle) +At Death's Door > Slot 1`}</li>
            <li parentName="ul">{`+Confident Fighter > At Death's Door `}<strong parentName="li">{`(Swap)`}</strong></li>
          </ul></li>
      </ul>
    </Menu>
    <Menu timing="Jump down stairs after first elevator. Needed before Ballet fight" mdxType="Menu">
      <h5 {...{
        "id": "weapons-3"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Delaram`}</li>
      </ul>
    </Menu>
    <p>{`Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-8"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: +15 Might (61)`}</li>
        <li parentName="ul">{`Lune: +15 Luck (24)`}</li>
        <li parentName="ul">{`Verso: +18 Might (50)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-6"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: +Sealed Fate, +Card Weaver`}</li>
        <li parentName="ul">{`Sciel: Equip Card Weaver Right-Bottom, Equip Sealed Fate Left-Bottom, Equip Twilight Slash Right-Middle`}</li>
      </ul>
    </Menu>
    <p>{`Run into group of Ballets.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "ballets-027"
      }}>{`Ballets (0:27)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`21624XP (NB), $1410, Ballaro LV13`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-12"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Perfect Recovery`}</li>
        <li parentName="ul">{`Lune: Wildfire (Fail QTE)`}</li>
        <li parentName="ul">{`Sciel: Skip`}</li>
      </ul>
      <p>{`Have them kill Sciel, bring in 2nd party.`}</p>
      <h5 {...{
        "id": "turn-1-16"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Monoco/Maelle: Flee`}</li>
      </ul>
    </Battle>
    <Menu timing="Any smaller jump before Glissando" mdxType="Menu">
      <h5 {...{
        "id": "weapons-4"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Dualiso`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Color of Lumina`}</strong>{` directly on the way.`}</p>
    <Menu timing="Big jump down before area with Tisseur" mdxType="Menu">
      <h5 {...{
        "id": "pictos-21"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Immaculate > Slot 2`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-9"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`-Energising Start I`}</li>
            <li parentName="ul">{`+Critical Moment`}</li>
            <li parentName="ul">{`(R2) +At Death's Door`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "glissando-350757hp-058"
      }}>{`Glissando 350757HP (0:58)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`51897XP, $2820, 1 Resplendent Chroma Catalyst`}<br parentName="p"></br>{`
`}{`515 speed seems to be the cutoff for him to not get 2 moves in T1.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Enchants its target: 1 hit. 2 explosions > Parry. Use rhythm.`}</li>
          <li parentName="ul">{`Smashes its head: 2 Parry, can visually/audio react`}</li>
          <li parentName="ul">{`Smashes its tail: 3 Parry, need to find cue. 1st visual on slowdown, 2nd audio, 3rd delayed audio.`}</li>
          <li parentName="ul">{`Summons ballets: 3 jumps, easy.`}</li>
          <li parentName="ul">{`Attacks with her fabric: one on each character, not sure on timing cue yet.`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-0-13"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Energy Tint Sciel`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Card Weaver > Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`If enchant attack, Sciel can shoot a bit to kill without burn damage.`}</p>
      <h5 {...{
        "id": "turn-1-17"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Shoot till C Rank, Leadership`}</li>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Sciel: Gradient > Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Battle>
    <Menu timing="Cutscene menu entering Sirene fight" mdxType="Menu">
      <h5 {...{
        "id": "weapons-5"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Delaram`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "sirene-303990hp-108"
      }}>{`Sirene 303990HP (1:08)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`129744XP, $7050, Tisseron + Energising Turn + Resplendent Chroma Catalyst x3`}<br parentName="p"></br>{`
`}{`She goes frantic at 80%? HP? After she does, her next move will be Grand Ballet.`}<br parentName="p"></br>{`
`}{`If you transition her there with a parry off her 1st move, she will skip her 2nd move.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Glissandos: 2 Parries`}</li>
          <li parentName="ul">{`Charm: 1 Parry, same timing as Glissando enchants. 2 Explosions > Parry`}</li>
          <li parentName="ul">{`Seduce: Gradient`}</li>
          <li parentName="ul">{`Grand Ballet: 5 Hits, watch ballets + audio cue. 1st one is earlier than you'd think, last one you have to be patient for.`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-0-14"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Card Weaver > Twilight Slash`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If she goes frantic before her move, we did too much damage. Adjust with QTEs next time.`}</p>
      </blockquote>
      <p>{`Parry Glissando's, she should go frantic`}</p>
      <blockquote>
        <p parentName="blockquote">{`If you still have Dualiso on, Attack before Leadership`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-18"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Leadership`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Sciel: Gradient > Sealed Fate`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "camp-6"
    }}>{`Camp`}</h3>
    <p>{`Go to sleep`}</p>
    <h3 {...{
      "id": "the-continent-2"
    }}>{`The Continent`}</h3>
    <p>{`Go to the Monolith`}</p>
    <h3 {...{
      "id": "the-monolith"
    }}>{`The Monolith`}</h3>
    <Menu timing="Before Feetress, preferably on jump into roll" mdxType="Menu">
      <h5 {...{
        "id": "formation-4"
      }}>{`Formation`}</h5>
      <p>{`-Verso, +Maelle, -Lune, -Sciel`}</p>
    </Menu>
    <Menu timing="Cutscene entering Feetress fight" mdxType="Menu">
      <h5 {...{
        "id": "weapons-6"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Tisseron`}</li>
        <li parentName="ul">{`Verso: Dualiso`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "the-feetress"
      }}>{`The Feetress`}</h4>
      <p>{`Skip x2`}</p>
    </Battle>
    <Menu timing="Before Chevaliers fight" mdxType="Menu">
      <p><em parentName="p">{`Try to spread this menu out between jumps.`}</em></p>
      <h5 {...{
        "id": "formation-5"
      }}>{`Formation`}</h5>
      <p>{`+Verso, -Maelle, +Lune, +Sciel`}</p>
      <h5 {...{
        "id": "pictos-22"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Energising Turn > Combo Attack`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Combo Attack > Critical Moment`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Weakness Gain`}</strong>{` at the end of the `}<strong parentName="p">{`Stone Wave Cliffs`}</strong>{` section. It's behind the statue on the right.`}</p>
    <p>{`Pick up `}<strong parentName="p">{`Resplendant Chroma Catalyst`}</strong>{` at the end of `}<strong parentName="p">{`Tainted Stone Wave Cliffs`}</strong>{`.`}</p>
    <p>{`Go to any flag along the way.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-9"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +3 Might (18), +6 Agility (42)`}</li>
        <li parentName="ul">{`Verso: +6 Agility (34) `}<em parentName="li">{`You can give more, it doesn't matter`}</em></li>
        <li parentName="ul">{`Sciel: +9 Luck (18)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-7"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: +All Set, Equip Right-Top`}</li>
        <li parentName="ul">{`Lune: +Storm Caller, Equip Right-Top`}</li>
      </ul>
    </Menu>
    <p>{`In Lumiere, fight the first battle with Chevaliers.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "chevaliers"
      }}>{`Chevaliers`}</h4>
      <ul>
        <li parentName="ul">{`Lune Ice Lance, rest skip. Bring in 2nd party, flee.`}</li>
      </ul>
    </Battle>
    <Menu timing="Cutscene entering Renoir 2 fight" mdxType="Menu">
      <h5 {...{
        "id": "lumina-10"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso: +Energising Start I (Insurance for T1 of Paintress)`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "renoir-2-370890hp-125"
      }}>{`Renoir 2 370890HP (1:25)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`173736XP, $8520, Second Chance + 3 Resplendent Chroma Catalyst`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Attempts to Vanish: 2 hit, Parry into Gradient. Parry right before he hits black orb. Gradient when back turned.`}</li>
          <li parentName="ul">{`Melee Combo: 6 hit`}</li>
          <li parentName="ul">{`Incredible amount of chroma: 2 Parries, Gradient. Parry as soon as you see the ball shrink.`}</li>
          <li parentName="ul">{`Waves of Chroma: 5 Parry, last is delayed`}</li>
          <li parentName="ul">{`Attacks from a distance: 4 attacks, 1st 3 parry on slow down. 4th is ground pound.`}</li>
        </ul>
      </blockquote>
      <p>{`You want to counter all his attacks unless you got an AoE counter T1, then you can possibly skip the second.`}<br parentName="p"></br>{`
`}{`On this patch the damage is WAY tighter, you need to get his HP as close to half as possible with Verso. There's a lot less wiggle room now.`}</p>
      <h5 {...{
        "id": "turn-0-15"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > 1 Shot, Leadership`}</li>
        <li parentName="ul">{`Lune: Storm Caller`}</li>
        <li parentName="ul">{`Sciel: Focused Fortell (1.2)`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-19"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Powerful`}</li>
        <li parentName="ul">{`Sciel: Sealed Fate`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-9"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Shots, Berserk Slash / Defiant Strike / Attack. You need to control damage here to get him as close to half as possible.`}</li>
        <li parentName="ul">{`Sciel: Headshots until 2 AP, Gradient > Sealed Fate`}</li>
      </ul>
      <p>{`This should kill, if not Abandon Battle instantly and retry.`}</p>
    </Battle>
    <Menu timing="Before Paintress" mdxType="Menu">
      <h5 {...{
        "id": "pictos-23"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Weakness Gain > Inverted Affinity`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-11"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Glass Cannon`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`-Inverted Affinity`}</li>
            <li parentName="ul">{`+Glass Cannon`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu timing="Cutscene entering Paintress fight" mdxType="Menu">
      <h5 {...{
        "id": "lumina-12"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+At Death's Door`}</li>
            <li parentName="ul">{`+Critical Moment`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "the-paintress-482157hp-410"
      }}>{`The Paintress 482157HP (4:10)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`173736XP, $8519, Painted Power + 3 Resplendent Chroma Catalyst`}<br parentName="p"></br>{`
`}{`Need >= 744 speed for Rush strat.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Void Meteors: 7 projectiles left to right. They kind of explode before launching, parry as soon as you see it.`}</li>
          <li parentName="ul">{`Gradient Attack: 1 Gradient`}</li>
          <li parentName="ul">{`Chroma Waves: 4 hits, 2nd one right after 1st. Audio cue works. Parry on start of cue.`}</li>
          <li parentName="ul">{`Scatters Chroma: 5 hits, parry once the black waves go into the circle. No more waves around circle > parry.`}</li>
          <li parentName="ul">{`Manipulates Rocks from the Monolith: 3 hit AoE, parry after the rock moves back?`}</li>
        </ul>
      </blockquote>
      <p>{`You want to slightly underdamage, so you can kill with the parry counter on her 4th move.`}</p>
      <h5 {...{
        "id": "turn-0-16"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Skip`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`Dodge Meteors`}</p>
      <h5 {...{
        "id": "turn-1-20"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: (Shoot and/or Attack for Rank C), Leadership`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: All Set`}</li>
      </ul>
      <p>{`Parry Gradient, Parry Chroma Waves and counter.`}</p>
      <blockquote>
        <p parentName="blockquote">{`Might need to control damage here, in testing it was fine.`}<br parentName="p"></br>{`
`}{`Defiant Strike worked in testing instead of Berserk Slash, but it was tight.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-2-10"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Verso: `}<strong parentName="li">{`Attack`}</strong>{` > Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Sciel: Gradient > Sealed Fate`}</li>
      </ul>
      <p>{`Parry all 5 chroma scatters, transition with counter.`}</p>
      <h4 {...{
        "id": "phase-2"
      }}>{`Phase 2`}</h4>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Summons giant brush of light: 3 hit aoe, parry on swing. Has audio cue similar to Chroma Waves`}</li>
          <li parentName="ul">{`Flies into the air: 5 hit, 2nd dodge on twirl, 3rd is slow, 4th is right after 3rd.`}</li>
          <li parentName="ul">{`Tears reality apart: 5 projectiles, dodge / parry at their "arc". Randomly start from left or right.`}</li>
          <li parentName="ul">{`Paintress unleashes: 7 single target into AoE`}</li>
          <li parentName="ul">{`Attacks from afar: Jump into 3 parry. Patient for jump`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-1-21"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Powerful`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Gradient > Sealed Fate`}</li>
      </ul>
      <p>{`She will get 2 turns here, Counter the Giant Brush and dodge "Flies into the Air".`}</p>
      <h5 {...{
        "id": "turn-2-11"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Sciel: Gradient > Sealed Fate`}</li>
      </ul>
      <h4 {...{
        "id": "phase-3-72323hp"
      }}>{`Phase 3 ~72323HP`}</h4>
      <h5 {...{
        "id": "turn-1-22"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Defiant Strike`}</li>
        <li parentName="ul">{`Sciel: Sealed Fate`}</li>
      </ul>
    </Battle>
    <h2 {...{
      "id": "act-iii"
    }}>{`Act III`}</h2>
    <h3 {...{
      "id": "lumiere"
    }}>{`Lumiere`}</h3>
    <Menu timing="Cutscene before talking to Renoir" mdxType="Menu">
      <h5 {...{
        "id": "pictos-24"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Painted Power`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`-Glass Cannon`}</li>
            <li parentName="ul">{`-Combo Attack`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "camp-7"
    }}>{`Camp`}</h3>
    <p>{`Talk to everyone, talk to campfire, Option 2`}</p>
    <h3 {...{
      "id": "lumiere-1"
    }}>{`Lumiere`}</h3>
    <Menu timing="Before Creation, preferably on jumps" mdxType="Menu">
      <p><em parentName="p">{`I like to split Sciel and Maelle's parts between 2 jumps.`}</em></p>
      <h5 {...{
        "id": "formation-6"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`-Everyone except Maelle`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-25"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel`}<ul parentName="li">
            <li parentName="ul">{`+Combo Attack > Confident Fighter`}</li>
            <li parentName="ul">{`+Glass Cannon > Immaculate`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle`}<ul parentName="li">
            <li parentName="ul">{`+Immaculate`}</li>
            <li parentName="ul">{`+Confident Fighter`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Talk to Merchant.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-2"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`8 Polished Chroma Catalyst (10 total)`}</li>
        <li parentName="ul">{`5 Resplendent Chroma Catalyst (18 total)`}</li>
        <li parentName="ul">{`(If none owned) 1 Recoat`}</li>
      </ul>
    </Menu>
    <p>{`Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-10"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: `}<strong parentName="li">{`Recoat`}</strong>{`. +All Agility (96)`}</li>
        <li parentName="ul">{`Maelle: +9 Might (59) +18 Luck (18)`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Stendhal Left-Middle is for muscle memory, Left-Top is faster.`}</p>
      </blockquote>
      <h5 {...{
        "id": "learn-skills-8"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +Stendhal,`}</li>
        <li parentName="ul">{`Maelle: Equip Stendhal Left-Middle`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-weapons-3"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Medalum +11 (17)`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-expedition-resources"
      }}>{`Upgrade Expedition Resources`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +8 Lumina (35)`}</li>
      </ul>
    </Menu>
    <Menu timing="Before Creation" mdxType="Menu">
      <h5 {...{
        "id": "lumina-13"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +Glass Cannon`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Want it before Creation to guarantee Maelle death.`}</p>
      </blockquote>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "creation"
      }}>{`Creation`}</h4>
      <h5 {...{
        "id": "turn-1-23"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Skip`}</li>
      </ul>
      <p>{`Maelle dies, 2nd party flee.`}</p>
    </Battle>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-7"
      }}>{`Formation`}</h5>
      <p>{`+Verso, +Sciel, -Maelle, +Maelle`}</p>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "renoir-3-766292hp-201"
      }}>{`Renoir 3 766292HP (2:01)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`219600XP, $9800`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul"><strong parentName="li">{`Phase 2 moves`}</strong>{`.`}</li>
          <li parentName="ul">{`Pool of Darkness: Ground Slam into 2 Explosions, simple audio cues.`}</li>
          <li parentName="ul">{`Void Meteors: 5 Projectiles, Pattern is BL TR BR TL. 1st is later than it looks, want to dodge as they hit ground.`}</li>
          <li parentName="ul">{`Attacks Frantically: 7 hit into Gradient`}</li>
          <li parentName="ul">{`Attacks Swiftly: 6 Single Target, 4 is right after 3`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-0-17"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: All Set`}</li>
        <li parentName="ul">{`Verso: Attack > 2 Shots, Leadership`}</li>
        <li parentName="ul">{`Maelle: Stendhall `}<strong parentName="li">{`(1.2 + 1.1 QTE)`}</strong>{`. Should do ~751k`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-24"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Intervention Maelle`}</li>
        <li parentName="ul">{`Maelle: Gradient `}<em parentName="li">{`should push to phase 2`}</em></li>
      </ul>
      <h5 {...{
        "id": "turn-11"
      }}>{`Turn 1.1`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Stendhall `}<strong parentName="li">{`(1.2 + 1.2 QTE)`}</strong></li>
      </ul>
    </Battle>
    <p>{`Fight as Maelle.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "verso-157188hp-007"
      }}>{`Verso 157188HP (0:07)`}</h4>
      <p>{`Rain of Fire (Fail QTE)`}</p>
    </Battle>
    <p>{`Time on fight end.`}</p>
    <h2 {...{
      "id": "bonus-strats"
    }}>{`Bonus Strats`}</h2>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "fast-dualliste-71106hp-140215"
      }}>{`Fast Dualliste 71106HP (1:40/2:15)`}</h4>
      <p>{`Good or bad fight depends on targetting, bad fight loses ~30s.`}<br parentName="p"></br>{`
`}{`1st phase you really want Sciel or Verso target. 2nd phase you NEED Verso target at the start.`}</p>
      <h5 {...{
        "id": "turn-0-18"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-25"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation if Verso Target / Energy Tint Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Defiant Strike / Berserk Slash`}</li>
      </ul>
      <p>{`Phase transitions here. `}<strong parentName="p">{`Notation is good / bad fight`}</strong>{`. Good fight is ONLY if Verso is targeted on his 1st attack.`}<br parentName="p"></br>{`
`}{`If good fight, parry everything. If not, dodge everything, you want to do less than half his HP on this turn.`}</p>
      <h5 {...{
        "id": "turn-2-12"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Tint Sciel if under 5AP or Attack or Immolation / Skip`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso > Berserk Slash / Tint if needed, else nothing`}</li>
      </ul>
      <p>{`Good fight kills here.`}</p>
      <h5 {...{
        "id": "turn-3-6"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack or Immolation or nothing`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
    </Menu>
    <h2 {...{
      "id": "archive"
    }}>{`Archive`}</h2>
    <h4 {...{
      "id": "spring-meadows-lanceram-volester-abbest-70xp-216-019"
    }}>{`Spring Meadows Lanceram Volester Abbest 70XP $216 (0:19)`}</h4>
    <h5 {...{
      "id": "turn-0-19"
    }}>{`Turn 0`}</h5>
    <ul>
      <li parentName="ul">{`Gustav`}<ul parentName="li">
          <li parentName="ul">{`Shoot Volester 3 times to kill (main body, hitting weakness does less)`}</li>
          <li parentName="ul">{`Then shoot other weakpoints and attack Lanceram (default)`}</li>
        </ul></li>
      <li parentName="ul">{`Lune: Ice Lance Abbest (default)`}</li>
    </ul>
    <p>{`Parry Lanceram, Abbest dies to burn`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "flying-waters-bruler--cruleram-028"
      }}>{`Flying Waters Bruler & Cruleram (0:28)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1069XP, $400, 2 Chroma Catalyst?`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-26"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot Bruler`}</li>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Maelle: Shoot Bruler Weakpoint, Swift Strike Bruler`}</li>
      </ul>
      <p>{`Dodge Cruleram, no need to parry.`}</p>
      <h5 {...{
        "id": "turn-2-13"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot Cruleram`}</li>
        <li parentName="ul">{`Lune: Skip`}</li>
        <li parentName="ul">{`Maelle: Percee Cruleram`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "swc-rocher-3367hp-1575xpnb-316-011"
    }}>{`SWC Rocher 3367HP 1575XP(NB) $316 (0:11)`}</h4>
    <ul>
      <li parentName="ul">{`Lune: Wildfire (fail QTE) `}</li>
      <li parentName="ul">{`Gustav: Marking Shot`}</li>
      <li parentName="ul">{`Maelle: Percee`}</li>
    </ul>
    <h2 {...{
      "id": "timings"
    }}>{`Timings`}</h2>
    <h3 {...{
      "id": "spring-meadows-1"
    }}>{`Spring Meadows`}</h3>
    <p>{`The $720 chroma detour takes 11.5s.`}<br parentName="p"></br>{`
`}{`Empowering Attack Picto is ~15s detour after Eveque.`}</p>
    <h3 {...{
      "id": "flying-waters-1"
    }}>{`Flying Waters`}</h3>
    <p>{`The Bruler than jumps down after Manor can be done pretty quick. $466, 1340XP, Bruleram.`}<br parentName="p"></br>{`
`}{`The Bruler + Crueler fight gives 1069XP $400`}<br parentName="p"></br>{`
`}{`Money pickups after tunnel cost ~6.5s for $990`}</p>
    <h3 {...{
      "id": "esquies-nest-1"
    }}>{`Esquie's Nest`}</h3>
    <p>{`Backtracking after Francois is 12s faster, but loses $1305 and Colour of Lumina.`}<br parentName="p"></br>{`
`}{`Flagging after Esquie saves ~13s, but loses Energising Start III.`}</p>
    <h3 {...{
      "id": "visages-1"
    }}>{`Visages`}</h3>
    <p>{`Killing self with Wildfire + Perfect Recovery > Flee: `}{`~`}{`14.5s`}<br parentName="p"></br>{`
`}{`Killing self with Wildfire + Perfect Recovery > 2nd party: `}{`~`}{`21s`}<br parentName="p"></br>{`
`}{`Killing self with 2 Moisonneusse (2 short combo) > `}{`~`}{`34s`}</p>
    <h3 {...{
      "id": "sirene-1"
    }}>{`Sirene`}</h3>
    <p>{`Standard Wildfire Ballet death: 29s`}<br parentName="p"></br>{`
`}{`Enemies before Glissando: 32s`}</p>
    <h3 {...{
      "id": "other"
    }}>{`Other`}</h3>
    <p>{`Upgrading Healing Tint when near curator: 4s`}</p>
    <h2 {...{
      "id": "routing-ideas-to-explore"
    }}>{`Routing Ideas to Explore`}</h2>
    <p>{`Could be worth it to pick up Staggering Attack in Flying Waters and use that for Gustave speed. You would then be able to dump quite a bit more into Might before Goblu. I think you'd need 2 Agi at first flag, and 1 more Agi somewhere later.`}<br parentName="p"></br>{`
`}{`I opted out of this because fast Goblu seems like a dream anyway and I didn't like what it did to the menus. If doing this, leave Dodger on Gustave until after you get Staggering Attack.`}</p>
    <p>{`Upgrading Bruleram to LVL4 might be worth it, would guarantee fast Petank, gets you better Sakapatates and better tournament. The downside is with no drops you wouldn't be able to get Medalum LV6 before Francois. And it takes a seperate Curator trip to upgrade Bruleram.`}</p>
    <p>{`Even though we need an extra battle with First Strike, it might still be better to take the Lanceram LV6 fight over Delaram.`}</p>
    <p>{`Instead of killing the Rocher, there's a group right by First Strike that can be cleared in 16s with Medalum LV6. That group drops more XP, money, and a Chation LV7 which might be very useful for Axons. Script is Marking Shot, Wildfire self, Maelle shoots fliers 4 times each, Percee.`}</p>
    <p>{`Might be worth exploring other kill setups for the Chalier in Forgotten Battlefield, simply so we can get 1 more point on First Strike. Something like First Strike Maelle RoF opening or something. Don't think it's good though (and crits can screw you?).`}</p>
    <p>{`We can give Verso First Strike before Monoco. The menu just felt clunky to me, and I think it would be about the same speed. You would just Powerful & Intervention T1, and Attack > Tint T2.`}</p>
    <p>{`We can invest more Might into Verso in Old Lumiere, I just don't see enough of a benefit.`}</p>
    <p>{`Could still be worth getting Auto Rush despite getting Glass Cannon, I just didn't want to dig into this.`}</p>
    <p>{`Mask Keeper just needs work in general. Hoping to find a fight that let's you get a fast fight with good RNG but still win with bad RNG.`}</p>
    <h2 {...{
      "id": "changelog"
    }}>{`Changelog`}</h2>
    <h5 {...{
      "id": "12926"
    }}>{`1/29/26`}</h5>
    <ul>
      <li parentName="ul">{`Give Sciel 3 more Might in Old Lumiere`}</li>
      <li parentName="ul">{`Added note on learning Rain of Fire before Ultimate Sakapatate`}</li>
    </ul>
    <h5 {...{
      "id": "12526"
    }}>{`1/25/26`}</h5>
    <ul>
      <li parentName="ul">{`These are just note fixes, route is unchanged`}</li>
      <li parentName="ul">{`Don't remve DE2 from Verso in Monoco Station`}</li>
      <li parentName="ul">{`Fix Sciel stat attribution in Old Lumiere`}</li>
      <li parentName="ul">{`Add Visages Merchant into notes, it was completely missing.`}</li>
      <li parentName="ul">{`Pick up Color of Lumina in Sirene (not needed but costs no time)`}</li>
    </ul>
    <h5 {...{
      "id": "12426"
    }}>{`1/24/26`}</h5>
    <ul>
      <li parentName="ul">{`Goblu fight is 5T by default.`}</li>
      <li parentName="ul">{`Fight Petank in Ancient Sanctuary`}</li>
      <li parentName="ul">{`Added note to go for double Powerful if Maelle didn't crit Percee`}</li>
      <li parentName="ul">{`29 Might on Maelle is now required for Tournament`}</li>
      <li parentName="ul">{`Upgrade Lighterim to 8 and Medalum to 6 after Gestral Village`}</li>
      <li parentName="ul">{`Sciel gets 1 Agility now at Esquie's Nest. This fixes Dualliste turn order (stats were the same as last patch, think this breaking is a patch issue).`}</li>
      <li parentName="ul">{`No longer get $1775 on Continent by Chromatic Bruler`}</li>
      <li parentName="ul">{`No longer do Continent fight for Lanceram 6`}</li>
      <li parentName="ul">{`Get Delaram in SWC`}</li>
      <li parentName="ul">{`Equip First Strike to Gustave and fight Rocher to setup Lune HP and get 1 point towards learning First Strike (needed for Monoco)`}</li>
      <li parentName="ul">{`Lampmaster P1 needs more counters now`}</li>
      <li parentName="ul">{`Verso now learns Powerful instead of Perfect Recovery at the start of Act II.`}</li>
      <li parentName="ul">{`Normal Dualliste is the default now, removed mention of fast fight in main notes.`}</li>
      <li parentName="ul">{`DONT put At Death's Door on Lune early now, need Verso to have it so we get 1 point of progress on it.`}</li>
      <li parentName="ul">{`Equip First Strike Lumina on Sciel before Monoco`}</li>
      <li parentName="ul">{`Monoco fight slightly altered`}</li>
      <li parentName="ul">{`Flag moved back to Old Lumiere instead of Monoco Station`}</li>
      <li parentName="ul">{`Lune now replaces Death's Door instead of First Strike for Renoir 1.`}</li>
      <li parentName="ul">{`Lune stats slightly different in Old Lumiere, Monoco maxes Agility`}</li>
      <li parentName="ul">{`No longer get Auto Rush`}</li>
      <li parentName="ul">{`Recommend 1 counter for damage on Renoir 1.`}</li>
      <li parentName="ul">{`Get Glass Cannon & Resplendant in Visages, use Monoco for death battle.`}</li>
      <li parentName="ul">{`Lune's Lumina menu is different (needs Augmented First Strike for death)`}</li>
      <li parentName="ul">{`Mask Keeper fight sucks now, I put in the non-RNG one but you can get a faster fight if willing to gamble on Lune AP generation. On this patch, you don't have the damage to back up bad pattern well.`}</li>
      <li parentName="ul">{`Camp before Sirene Scielson 11 Lighterim 14`}</li>
      <li parentName="ul">{`Sirene defaults to fast fight now using Delaram`}</li>
      <li parentName="ul">{`Pick up Resplendant in Monolith`}</li>
      <li parentName="ul">{`Monolith Lune stats upgrades are different`}</li>
      <li parentName="ul">{`Renoir 2 is very tight since Gradient no longer hits max damage. Need to be very close to half and do headshots.`}</li>
      <li parentName="ul">{`Lune & Sciel equip Glass Cannon before Paintress`}</li>
      <li parentName="ul">{`Paintress requires a Verso Attack T2, but phase 2 only need to counter giant brush to skip a Verso attack.`}</li>
      <li parentName="ul">{`Buy 5 Resplendants from Merchant following.`}</li>
      <li parentName="ul">{`Maelle gets 7 Lumina so she can get Glass Cannon`}</li>
      <li parentName="ul">{`Maelle no longer needs Last Chance because no way to get 2 Sciel turns before Creation, so just letting Creation kill us.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      